export default "__VITE_ASSET__CwmzZBIS__"